import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { firestoreConnect } from 'react-redux-firebase'
import { Redirect } from 'react-router-dom'
import Button from '@material-ui/core/Button';
import AddIcon from '@material-ui/icons/Add';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress'
import { saveFormData, resetFormData } from './store/dFormActions'
import Add from './Add'
import { getCollection } from '../../constant'

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import moment from 'moment'
import EditIcon from '@material-ui/icons/Edit';
import IconButton from '@material-ui/core/IconButton';


class List extends Component {

    state = {
        open: false
    }

    handleClose = () => {
        this.setState({ open: false, data: null })
    }

    componentDidMount() {
        const { listName } = this.props.form;
        // this.props.getListData(listName);
    }

    saveData = (data) => {
        const { form, saveFormData } = this.props;
        const { listName } = form
        this.props.saveFormData(listName, data);
    }

    render() {
        const { form, auth, dFormData, savedData, resetFormData, listData } = this.props;
        const { addButtonTitle, listTitle, createdAt, inputs, listName } = form

        console.log("savedData : ", savedData)
        if (savedData) {
            this.handleClose();
            resetFormData();
            // getListData(listName);
        }


        if (!auth.uid) return <Redirect to='/signin' />

        // if (!createdAt || !listData) {
        if (!createdAt) {
            return <Typography variant="h4" component="h3" gutterBottom align="center">
                <CircularProgress align="center" />
            </Typography>
        }

        console.log("listData : ", listData)

        return (<React.Fragment>
            <div style={{ width: '80%', margin: 'auto', maxWidth: 800, marginTop: 20 }}>
                <Typography style={{ marginLeft: 10 }} variant="h4">{listTitle}</Typography>
                <Button
                    onClick={() => { this.setState({ open: true }) }}
                    style={{ float: 'right', margin: '10px 2px -10px 0' }}
                    variant="contained"
                    color="primary"
                    startIcon={<AddIcon />}
                >{addButtonTitle} </Button>
                <div style={{ clear: 'both', height: 1, width: '100%' }}></div>

                {
                    listData && listData.length > 0
                        ?
                        <TableContainer style={{ marginTop: 20, marginBottom: 20 }} component={Paper}>
                            <Table size="small" aria-label="a dense table">
                                <TableHead>
                                    <TableRow>
                                        {
                                            inputs && inputs.length > 0 && inputs.map(({ id, title }) => {
                                                return <React.Fragment key={id}>
                                                    <TableCell>{title}</TableCell>
                                                </React.Fragment>
                                            })
                                        }
                                        <TableCell align="right">Updated At</TableCell>
                                        <TableCell align="right">Created At</TableCell>
                                        <TableCell align="right">Edit</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {
                                        listData.map((data, i) => {
                                            return (
                                                <TableRow key={data.id}>
                                                    {
                                                        inputs && inputs.length > 0 && inputs.map(({ id, title }) => {
                                                            return <React.Fragment key={id + title}>
                                                                <TableCell component="th" scope="row">
                                                                    {data[id]}
                                                                </TableCell>
                                                            </React.Fragment>
                                                        })
                                                    }
                                                    <TableCell align="right">{data.updatedAt ? moment(data.updatedAt.toDate()).calendar() : moment(data.createdAt.toDate()).calendar()}</TableCell>
                                                    <TableCell align="right">{moment(data.createdAt.toDate()).calendar()}</TableCell>
                                                    <TableCell align="right">
                                                        <IconButton onClick={() => { this.setState({ open: true, data }) }}>
                                                            <EditIcon />
                                                        </IconButton>
                                                    </TableCell>
                                                </TableRow>
                                            )
                                        })
                                    }
                                </TableBody>
                            </Table>
                        </TableContainer>
                        : <Typography variant="h5">There are no {listTitle}</Typography>
                }

            </div>
            <Add open={this.state.open} data={this.state.data} {...form} handleClose={this.handleClose} saveData={this.saveData} />
        </React.Fragment>
        )
    }
}

const mapDispatchToProps = dispatch => {
    return {
        // getListData: (listName) => dispatch(getListData(listName)),
        saveFormData: (listName, data) => dispatch(saveFormData(listName, data)),
        resetFormData: () => dispatch(resetFormData())
    }
}

const mapStateToProps = (state, ownProps) => {
    const id = ownProps.match.params.formId
    const listName = ownProps.match.params.firestoreList
    const forms = state.firestore.data.forms
    const form = forms ? forms[id] : null

    return {
        auth: state.firebase.auth,
        formData: state.formReducer,
        dFormData: state.dFormReducer,
        savedData: state.dAddFormReducer.savedData,
        form: { ...form, id, listName },
        profile: state.firebase.profile,
        listData: state.firestore.ordered[getCollection(state.firebase.profile, listName)]
    }
}

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    firestoreConnect((props) => {
        return [
            { collection: 'forms' },
            { collection: getCollection(props.profile, props.form.listName), orderBy: ['createdAt', 'desc'] },
        ]
    })
)(List);